// extracted by mini-css-extract-plugin
export default {"media":"AboutUsContent_media__q0iuA"};